<template>
  <div>
    <VTreeview
      :items="categories"
      activatable
      return-object
      dense
      v-model="model"
      hoverable
      class="v-height huntica-nice-scroll tree-view"
      @update:active="setSelectedCategory"
    />
  </div>
</template>

<script>
export default {
  name: 'VacancyPresetsCategories',
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: [],
    };
  },
  methods: {
    setSelectedCategory(category) {
      this.$emit('selectCategory', category);
    },
  },
};
</script>

<style scoped>

</style>
